'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Rule2 = require('./Rule');

var _Rule3 = _interopRequireDefault(_Rule2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Required = function (_Rule) {
    _inherits(Required, _Rule);

    function Required() {
        _classCallCheck(this, Required);

        return _possibleConstructorReturn(this, (Required.__proto__ || Object.getPrototypeOf(Required)).apply(this, arguments));
    }

    _createClass(Required, [{
        key: 'validate',
        value: function validate() {
            var type = (0, _lodash.capitalize)(_typeof(this.value));
            return this.tryHandleType(type);
        }
    }, {
        key: 'handleString',
        value: function handleString() {
            if (this.value.trim() === '') {
                return this.getMessage();
            }
        }
    }, {
        key: 'handleNumber',
        value: function handleNumber() {
            if (this.value <= 0) {
                return this.getMessage();
            }
        }
    }, {
        key: 'getMessage',
        value: function getMessage() {
            return 'the ' + this.getReadableFieldName() + ' field is required';
        }
    }, {
        key: 'tryHandleType',
        value: function tryHandleType(type) {
            var methodName = 'handle' + type;
            if (typeof this[methodName] !== 'function') {
                console.warn('Could not validate against the type of ' + type + '.', 'accepted types are String and Number');
                return;
            }
            return this[methodName]();
        }
    }]);

    return Required;
}(_Rule3.default);

exports.default = Required;